const DEFAULT_API_ORIGIN = "http://localhost:8000";

const normalizeApiOrigin = (value) => {
  if (!value) return null;

  let raw = String(value).trim().replace(/\/+$/, "");
  // Common typo from manual edits: hhttp://...
  raw = raw.replace(/^h+(?=http:\/\/)/i, "");

  if (!/^https?:\/\//i.test(raw)) {
    raw = `http://${raw}`;
  }

  try {
    const url = new URL(raw);
    if (!["http:", "https:"].includes(url.protocol)) return null;
    return `${url.protocol}//${url.host}`;
  } catch {
    return null;
  }
};

const pickApiOrigin = () => {
  const candidates = [
    process.env.REACT_APP_API_URL,
    process.env.REACT_APP_API_BASE_URL,
    DEFAULT_API_ORIGIN,
  ];

  for (const candidate of candidates) {
    const normalized = normalizeApiOrigin(candidate);
    if (normalized) return normalized;
  }

  return DEFAULT_API_ORIGIN;
};

// CRA env vars must start with REACT_APP_
export const API_BASE_URL = pickApiOrigin();
export const API_URL = pickApiOrigin();
